var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperationsHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1920,
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 811.74,
    y1: 137.44,
    x2: 1704.76,
    y2: 936.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ff5c35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ffa766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1165.5,
    y1: 1710.61,
    x2: 258.72,
    y2: 1097.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ff5c35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ffa766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 5451.57,
    y1: 14216.84,
    x2: 6344.59,
    y2: 15016.1,
    gradientTransform: "translate(6560 16000) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ff5c35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ffa766"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.74,1520a240,240,0,0,1-189.45-387.33c42.45-54.59,64-112.68,64-172.67s-21.52-118.08-64-172.67A240,240,0,0,1,595.2,492.67C703.18,631.53,760.26,793.13,760.26,960s-57.08,328.47-165.06,467.33A240.08,240.08,0,0,1,405.74,1520Z",
    fill: "#ff5c35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.26,1520a240.08,240.08,0,0,1-189.46-92.67c-108-138.86-165.06-300.46-165.06-467.33s57.08-328.47,165.06-467.33a240,240,0,1,1,378.91,294.66c-42.45,54.59-64,112.68-64,172.67s21.52,118.08,64,172.67A240,240,0,0,1,1514.26,1520Z",
    fill: "#ff5c35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M486.15,885.62a826.41,826.41,0,0,1-113.27-7.88,240,240,0,0,1,65.73-475.48c68.49,9.47,129.57-.94,181.52-30.93s91.5-77.69,117.55-141.74a240,240,0,0,1,444.64,180.82C1116.06,573.35,1004.64,703.58,860.13,787,747.21,852.21,619.65,885.62,486.15,885.62Z",
    fill: "#ff5c35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M960,1840a240,240,0,0,1-222.32-330.41c66.26-162.94,177.68-293.17,322.19-376.61s313-114.8,487.25-90.72a240,240,0,0,1-65.73,475.48c-68.49-9.47-129.57.94-181.52,30.93s-91.5,77.69-117.55,141.74A240,240,0,0,1,960,1840Z",
    fill: "#ff5c35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.85,885.62c-133.51,0-261-33.4-374-98.6C915.36,703.58,803.94,573.35,737.68,410.41a240,240,0,0,1,444.64-180.82c26,64,65.6,111.74,117.55,141.74s113,40.4,181.52,30.93a240,240,0,0,1,65.73,475.48A827.89,827.89,0,0,1,1433.85,885.62Z",
    fill: "url(#a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M960,1840a240,240,0,0,1-222.32-149.59c-26-64.05-65.6-111.74-117.55-141.74s-113-40.4-181.52-30.93a240,240,0,0,1-65.73-475.48c174.25-24.09,342.73,7.28,487.25,90.72s255.93,213.67,322.19,376.61A240,240,0,0,1,960,1840Z",
    fill: "url(#b)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1514.26,
    cy: 640,
    r: 240,
    fill: "#ff5c35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M487.15,1035.09c133.61,0,260.92,33.23,373.3,98.12,144,83.16,255.35,213.58,321.87,377.16a240,240,0,1,1-444.64,180.82c-26.31-64.7-65.75-112.57-117.23-142.29-39-22.52-83.6-33.85-133-33.85a357.4,357.4,0,0,0-48.82,3.47A240,240,0,0,1,372.88,1043,835.44,835.44,0,0,1,487.15,1035.09Z",
    fill: "url(#c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1920,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsHub);
export default __webpack_public_path__ + "static/media/OperationsHub.edf0717f6d6e97752f2b0ee06e51114c.svg";
export { ForwardRef as ReactComponent };